import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "../components/legal-page";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage title="Termos de uso" updated="28 de setembro de 2026">
      <p>
        Estes termos regulam o uso do Bridge, plataforma de operação de
        lojas em marketplaces. Ao criar uma conta, você aceita estas regras em
        nome da empresa que cadastrar.
      </p>

      <h2>O serviço</h2>
      <p>
        O Bridge conecta lojas autorizadas por você, importa pedidos,
        anúncios e perguntas, e sincroniza estoque quando a escrita no
        marketplace estiver habilitada. O trial dura 14 dias, com os limites
        descritos na página de planos. Planos pagos são cobrados pela Asaas;
        o Bridge não armazena dados de cartão.
      </p>

      <h2>Sua responsabilidade</h2>
      <ul>
        <li>Manter credenciais e o acesso OAuth das lojas sob o seu controle.</li>
        <li>
          Usar o produto só em lojas que você opera ou tem autorização para
          operar.
        </li>
        <li>
          Conferir estoque, preço e respostas antes de escrever no marketplace.
        </li>
        <li>
          Cumprir as regras do marketplace e a legislação aplicável às vendas.
        </li>
      </ul>

      <h2>Cobrança e cancelamento</h2>
      <p>
        Você pode cancelar a assinatura a qualquer momento em Plano. A cobrança
        para de ser gerada; o acesso e a sincronização seguem até o fim do
        período já pago. Depois disso, a sincronização pausa e a leitura dos
        dados já importados continua. Podemos suspender uma organização em caso
        de abuso, inadimplência ou risco à plataforma.
      </p>

      <h2>Disponibilidade</h2>
      <p>
        Nos esforçamos para manter o serviço no ar, mas webhooks de marketplace
        se perdem, APIs de terceiros falham e o sync pode atrasar. O Bridge não
        se responsabiliza por venda perdida, estoque divergente no marketplace
        ou decisão fiscal tomada com base nos dados exibidos aqui.
      </p>

      <h2>Encerramento</h2>
      <p>
        Você pode pedir o encerramento da conta e a exclusão dos dados, nos
        termos da política de privacidade. Podemos encerrar o acesso se estes
        termos forem violados.
      </p>
    </LegalPage>
  );
}
